export default "__VITE_ASSET__DgqWSFdl__"